//import 'bootstrap'; // bootstrap.js are called using normal wp style. If you call hare jquery and popper.js will be called automacticaly. 

import './scss/main.scss'


jQuery(document).ready(function($){    
  console.log('Js loading from child theme!')


  // $('[data-toggle="tooltip"]').tooltip()
  // $('.carousel').carousel()


  $('.option').on('click', function(){
    var parent_div = $(this).parent(".options-wrapper");

    if( parent_div.data('quiz') != 'enable' ){
      return;
    }

    if( $(this).hasClass('ans') )
    { 
      parent_div.data('quiz', 'disable');
      $(this).addClass('border-success bg-success text-light');

      $('.check-icon').removeClass('d-none')
      $('.check-icon').fadeIn()

      setTimeout(() => {
        $('.check-icon').addClass('d-none')
        // $('.check-icon').fadeIn()
      }, 1500);

      count_correct_ans();

    }else{
      parent_div.data('quiz', 'disable');
      $(this).addClass('border-danger bg-danger text-light animate__animated animate__headShake');

      var ans_div = parent_div.children('.ans')
      // ans_div.setProperty('--animate-duration', '2s');
      ans_div.addClass('border-success bg-success text-light animate__animated animate__pulse');

      count_incorrect_ans();

      
    }

  })

  function count_correct_ans(){
    var correct = sessionStorage.getItem('correct');
    if (correct === null) {
      sessionStorage.setItem('correct', 1);
    } else {
      var new_count = parseInt(correct);
      new_count++;
      sessionStorage.setItem('correct', new_count);
    }
    console.log(sessionStorage.getItem(correct));
  // show_score_flotting_button();

  }

  function count_incorrect_ans(){
    var incorrect = sessionStorage.getItem('incorrect');
    if (incorrect === null) {
      sessionStorage.setItem('incorrect', 1);
    } else {
      var new_count = parseInt(incorrect);
      new_count++;
      sessionStorage.setItem('incorrect', new_count);
    }
    console.log(sessionStorage.getItem('incorrect'));
  // show_score_flotting_button();

  }


  function show_score_flotting_button(){
    var correct = sessionStorage.getItem('correct');
    var incorrect = sessionStorage.getItem('incorrect');

    if (incorrect === null && incorrect === null) { return false }

    var score = parseInt(correct) - parseInt(incorrect);

    $('.raw-score').html(score)


  }

  // show_score_flotting_button();


  // Function to display the modal after 10 seconds
  // function openModal() {
  //   setTimeout(function() {
  //     $('#myModal').modal('show');
  //   }, 10000); // 10 seconds
  // }

  // // Function to hide the modal for 7 days
  // function hideModalFor7Days() {
  //   $('#myModal').modal('hide');
  //   localStorage.setItem("hideModal", true);
  //   setTimeout(function() {
  //     localStorage.removeItem("hideModal");
  //   }, 7 * 24 * 60 * 60 * 1000); // 7 days
  // }

  // // Check if the modal should be shown or hidden
  // $(document).ready(function() {
  //   var hideModal = localStorage.getItem("hideModal");
  //   if (!hideModal) {
  //     openModal();
  //   }
  // });

})



